import { Component, inject, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TableModule, TableRowSelectEvent } from 'primeng/table';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { PrimeTemplate } from 'primeng/api';
import { DokumenterService } from '@features/letpensiondk/letpensiondk-dokumenter/dokumenter.service';
import { LpDkDokumenterDatasource } from '@features/letpensiondk/letpensiondk-dokumenter/dokumenter.datasource';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { InputText } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { Toolbar } from 'primeng/toolbar';
import { Checkbox } from 'primeng/checkbox';

@Component({
  selector: 'app-letpensiondk-dokumenter-list',
  imports: [
    PrimeTemplate,
    TableModule,
    TableRowDirective,
    DatePipe,
    IconField,
    InputIcon,
    InputText,
    FormsModule,
    Toolbar,
    Checkbox,
  ],
  templateUrl: './letpensiondk-dokumenter-list.component.html',
  styleUrl: './letpensiondk-dokumenter-list.component.css',
})
export class LetpensiondkDokumenterListComponent {
  dokumenterService = inject(DokumenterService);
  datasource = inject(LpDkDokumenterDatasource);
  searchText = signal('');
  medtagSlettede = signal(false);

  data = this.datasource.data;

  onRowSelect(e: TableRowSelectEvent) {
    this.dokumenterService.selectDokument(e.data);
  }

  onSearch() {
    this.datasource.searchParams.set({
      text: this.searchText(),
      medtagSlettede: this.medtagSlettede(),
    });
  }
}
